import { type RefObject, useLayoutEffect, useRef } from 'react';

import {
  disableSubtreeTabIndex,
  MOBILE_MENU_FOCUSABLE_SELECTOR,
  restoreSubtreeTabIndex,
} from './mobileMenuFocusHelpers';

export function useMobileNavMainMenuFocus(
  mainMenuSectionRef: RefObject<HTMLDivElement | null>,
  isOpenSubDrawer: boolean,
): void {
  const prevSubDrawerOpenRef = useRef(false);

  useLayoutEffect(() => {
    const root = mainMenuSectionRef.current;
    if (!root) {
      return;
    }

    if (isOpenSubDrawer) {
      disableSubtreeTabIndex(root, 'mobileNavMainBackup');
    } else {
      restoreSubtreeTabIndex(root, 'mobileNavMainBackup');
    }
  }, [isOpenSubDrawer]);

  useLayoutEffect(() => {
    const wasOpen = prevSubDrawerOpenRef.current;
    prevSubDrawerOpenRef.current = isOpenSubDrawer;

    if (!wasOpen || isOpenSubDrawer) {
      return;
    }

    const root = mainMenuSectionRef.current;
    if (!root) {
      return;
    }

    const candidates = Array.from(
      root.querySelectorAll<HTMLElement>(MOBILE_MENU_FOCUSABLE_SELECTOR),
    );
    for (const el of candidates) {
      if (el.tabIndex < 0) {
        continue;
      }
      el.focus({ preventScroll: true });
      break;
    }
  }, [isOpenSubDrawer]);
}
